"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NatureOfRelationshipDifference = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.NatureOfRelationshipDifference = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.nature_of_relationship_difference.label',
    fallbackLabel: 'If you engage with both licensed and unlicensed Distributors, could you describe how the nature of your relationships with each differs? For instance, are there specific roles, responsibilities, or tasks that licensed Distributors are more likely to assume compared to unlicensed ones?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.entrust_other_contracted_entities', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.entrust_other_contracted_entities === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
